import type { FC } from "react";
import { UsersPage } from "./Users";

const UsersContainer: FC = () => {
  return <UsersPage />;
};

export default UsersContainer;
